<script>
    import { Router, Link, Route, navigate } from "svelte-routing";

    function goHome() {
      navigate("/", { replace: true });
  }
</script>

<!--Old logo https://img.icons8.com/material-sharp/48/ffffff/toy-train.png-->

<div class="header">
    <div on:click={goHome} class="left"><img style="margin-right:8px; height:4vh;"  src="./logo.png" alt="logo"/>Bourse aux jouets</div>
    <div class='right'>
        <slot></slot>
    </div>
    
</div>



<style>
.header{
    margin-top: 2vh;
    width: 90vw;
    height: 8vh;
    background-color: #262626;
    box-shadow:  20px 20px 56px #151515,
         -20px -20px 56px #373737;
    border-radius: 20px;
    display: flex;
    justify-content: start;
    flex-direction: row;
    align-items: center;
    color: white;
    font-family: 'Poppins', sans-serif;
    font-weight: 400;
    font-size: clamp(0.75rem, 1.5vw, 1.8rem);
    position: fixed;
    top : 0;
    z-index: 10;
    user-select: none;
    }

    .left{
        width: 20%;
        padding: 5px;
        cursor: pointer;
        display: flex;
        flex-direction: row;
        align-items: center;
        font-size: clamp(0.75rem, 1vw, 1.8rem);
    }

    .right{
        width: 80%;
        display: flex;
        flex-direction: row-reverse;
        padding: 5px;
    }

   /* @media screen and (max-width: 1590px) {
    .header {
    font-size: 1em;
  }

  @media screen and (max-width: 420px) {
    .header {
    font-size: .75em;
  }
}
    }*/


    @media (orientation : portrait){
        .header{
    margin-top: 2vh;
    width: 90vw;
    height: fit-content;
    background-color: #262626;
    box-shadow:  20px 20px 56px #151515,
         -20px -20px 56px #373737;
    border-radius: 20px;
    display: flex;
    justify-content: start;
    flex-direction: row;
    align-items: center;
    color: white;
    font-family: 'Poppins', sans-serif;
    font-weight: 400;
    font-size: clamp(0.75rem, 1.5vw, 1.8rem);
    
    user-select: none;
    }

    .left{
        width: 20%;
        padding: 5px;
        cursor: pointer;
        display: flex;
        flex-direction: row;
        align-items: center;
        font-size: clamp(0.75rem, 1vw, 1.8rem);
    }

    .right{
        width: 80%;
        display: flex;
        flex-direction: column-reverse;
        align-items: center;
        padding: 5px;
        font-size: clamp(1.5rem, 3vw, 1.8rem);
    }


    }
</style>